export default __webpack_public_path__ + "static/media/image1.8eca8813.png";